import { put, call } from 'redux-saga/effects'
import {
  chargingTokenDesignApiService,
  handleError,
} from 'Services/ApiService.js'
import chargingTokenDesignActions from 'Stores/ChargingTokenDesign/Actions'
import i18n from 'i18next'
import { IFToastMessage } from 'Components'
import { toaster } from 'rsuite'

export function* fetchChargingTokenDesigns({ offset }) {
  yield put(chargingTokenDesignActions.fetchChargingTokenDesignsLoading())

  try {
    const { data } = yield call(chargingTokenDesignApiService.get, '/', {
      params: {
        offset: offset,
      },
    })
    yield put(
      chargingTokenDesignActions.fetchChargingTokenDesignsSuccess(
        offset,
        data.designs,
        data.nextOffset,
      ),
    )
  } catch (e) {
    yield put(chargingTokenDesignActions.fetchChargingTokenDesignsError(e))
    handleError(e)
  }
}

export function* fetchAllChargingTokenDesigns({ offset, designName }) {
  yield put(chargingTokenDesignActions.fetchAllChargingTokenDesignsLoading())

  try {
    const { data } = yield call(
      chargingTokenDesignApiService.get,
      '/allDesigns',
      {
        params: {
          offset: offset,
          designName: designName,
        },
      },
    )
    yield put(
      chargingTokenDesignActions.fetchAllChargingTokenDesignsSuccess(
        offset,
        data.response.designs,
        data.response.nextOffset,
      ),
    )
  } catch (e) {
    yield put(chargingTokenDesignActions.fetchAllChargingTokenDesignsError(e))
    handleError(e)
  }
}
export function* addChargingTokenDesign({ design }) {
  yield put(chargingTokenDesignActions.addChargingTokenDesignLoading())
  try {
    const { data } = yield call(chargingTokenDesignApiService.post, '/', {
      name: design.name,
      design: design.description,
    })

    yield put(chargingTokenDesignActions.addChargingTokenDesignSuccess(data))
    toaster.push(
      <IFToastMessage
        type="success"
        text={i18n.t('ChargingTokenPage.ChargingTokenDesignAdded')}
      />,
    )
  } catch (e) {
    yield put(chargingTokenDesignActions.addChargingTokenDesignError(e))
    handleError(e)
  }
}

export function* editChargingTokenDesign({ id, design }) {
  yield put(chargingTokenDesignActions.editChargingTokenDesignLoading())
  try {
    const { data } = yield call(chargingTokenDesignApiService.patch, `/${id}`, {
      name: design.name,
      design: design.description,
    })

    yield put(chargingTokenDesignActions.editChargingTokenDesignSuccess(data))
  } catch (e) {
    yield put(chargingTokenDesignActions.editChargingTokenDesignError(e))
    handleError(e)
  }
}

export function* getChargingTokenDesignsCount() {
  yield put(chargingTokenDesignActions.getChargingTokenDesignsCountLoading())
  try {
    const { data } = yield call(chargingTokenDesignApiService.get, '/count')
    yield put(
      chargingTokenDesignActions.getChargingTokenDesignsCountSuccess(
        data.count,
      ),
    )
  } catch (e) {
    yield put(chargingTokenDesignActions.getChargingTokenDesignsCountError(e))
    handleError(e)
  }
}
export function* deleteChargingTokenDesign({ id }) {
  yield put(chargingTokenDesignActions.deleteChargingTokenDesignLoading())
  try {
    yield call(chargingTokenDesignApiService.delete, `/${id}`)
    yield put(chargingTokenDesignActions.deleteChargingTokenDesignSuccess(id))
    toaster.push(
      <IFToastMessage
        type="success"
        text={i18n.t('ChargingTokenPage.ChargingTokenDesignDeleted')}
      />,
    )
  } catch (e) {
    yield put(chargingTokenDesignActions.deleteChargingTokenDesignError(e))
    handleError(e)
  }
}
